
/**
 * Fetch data from endpoint
 * @param endpoint
 * @param callback
 */
const fetchEndpoint = (endpoint: string, callback: (data: any) => void) => {
    if (endpoint) {
        fetch(endpoint)
            .then((response: Response) => {
                return response.json();
            })
            .then((data: JSON) => {
                callback(data);
            })
            .catch((reason: any) => {
                console.log("Fetch error :", reason);
            });
    }
};

export {
    fetchEndpoint
};
